import { Module } from "vuex";
import { state } from "./state";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { getters } from "./getters";
import { IFlowState } from "./types";
import { RootState } from "@/store/types";

const namespaced: boolean = true;

export const flowModule: Module<IFlowState, RootState> = {
  namespaced,
  state,
  actions,
  mutations,
  getters,
};
